import project1 from "../assets/project1.png";
import project2 from "../assets/project2.png";
import project3 from "../assets/project3.png";
import project4 from "../assets/project4.png";
import project5 from "../assets/project5.png";
import project6 from "../assets/project6.png";
import project7 from "../assets/project7.png";
import project8 from "../assets/booking-app-pic3.png";
import project9 from "../assets/booking-app-pic2.png";
import project10 from "../assets/booking-app-pic1.png";
const projects = [
  {
    id: 1,
    category: "Redux",
    image: project1,
    link_github: "https://github.com/oscaroguzhan/project-ewallet",
    title: "Create react e-wallet app",
    text: "React-Router-Redux Toolkit",
  },
  {
    id: 2,
    category: "React",
    image: project2,
    link_github: "https://github.com/oscaroguzhan/React-Game-of-thrones-App",
    title: "React movie characters app",
    text: "React-fetch API, CSS3",
  },
  {
    id: 3,
    category: "Redux",
    image: project3,
    link_github: "https://github.com/oscaroguzhan/react-redux-bankomat-app",
    title: "Create react bankomat app",
    text: "React-Redux",
  },
  {
    id: 4,
    category: "React-Router",
    image: project4,
    link_github: "https://github.com/oscaroguzhan/activity-api-app",
    title: "Create react forum app",
    text: "React-Router-API",
  },
  {
    id: 5,
    category: "React",
    image: project5,
    link_github: "https://github.com/oscaroguzhan/React_contact_list_form_app",
    title: "Create contact list form",
    text: "React basics hooks, props, form",
  },
  {
    id: 6,
    category: "HTML5/CSS3",
    image: project6,
    link_github: "https://github.com/oscaroguzhan/ChallengesJS",
    title: "Create quiz app",
    text: "OOP with HTML and CSS",
  },
  {
    id: 7,
    category: "React",
    image: project7,
    link_github: "https://github.com/oscaroguzhan/ReactEC_BulletinBoard",
    title: "Create react app",
    text: "React basics hooks, props",
  },
  {
    id: 8,
    category: "MERN",
    image: project8,
    link_github: "https://github.com/oscaroguzhan/mern-booking-app-frontend.git",
    title: "Create mern-stack booking app (client site)",
    text: "React-Router, Styled-components",
  },
  {
    id: 9,
    category: "React",
    image: project9,
    link_github: "https://github.com/oscaroguzhan/mern-booking-app-frontend.git",
    title: "Create mern-stack booking app (client site)",
    text: "React-Router, Styled-components",
  },
  {
    id: 10,
    category: "React-Router",
    image: project10,
    link_github: "https://github.com/oscaroguzhan/mern-booking-app-frontend.git",
    title: "Create mern-stack booking app (client site)",
    text: "React-Router, Styled-components",
  },
  
];

export default projects;
